import { gql } from 'graphql.macro'

export default gql`
  fragment JobFragment on Job {
    progress
  }
`
